import React from 'react';
import { useTranslation } from 'react-i18next';

export default function InfoModal({ isOpen, onClose, title, message, children }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  // Scrolls inside the card when content is tall, wraps long names and emails, and keeps a margin on small screens
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full max-h-[85vh] overflow-y-auto">
        <h2 className="text-lg font-semibold mb-4 break-words [overflow-wrap:anywhere]">{title || 'Info'}</h2>
        <div className="mb-6 break-words [overflow-wrap:anywhere]">
          {message && <p>{message}</p>}
          {children}
        </div>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {t('common.ok')}
          </button>
        </div>
      </div>
    </div>
  );
}
